// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2uza4","right":"styles_right__EyM85"};